module.exports = __webpack_public_path__ + "static/media/logo_cie_relativement.6999aca1.png";